<template>

    <v-content>
        <v-container fluid>

            <panelcontainer>
                <div class="headline" slot="headline">Ürünler</div>
                <div slot="actions">
                    <v-btn tile color="indigo" small dark @click="exportExcell()">
                        <v-icon>{{mdiFileExcel}}</v-icon> Excel İndir
                    </v-btn>
                    <v-btn tile color="indigo" dark @click="editItem()">
                        <v-icon>{{mdiPlus}}</v-icon> Yeni Ürün Ekle
                    </v-btn>
                </div>
                <loading v-if="isLoading" text="Ürün listesi yükleniyor..." size="80" width="2" />

                <template v-if="!isLoading">
                    <table class="table table-striped table-borderless table-hover">
                        <thead>
							<tr>
								<th>
									<v-text-field v-model="search_category" outlined dense clearable hide-details :label="empty_label" placeholder="Ara" x-small></v-text-field>
								</th> 
								<th>
									<v-text-field v-model="search_name" outlined dense clearable hide-details :label="empty_label" placeholder="Ara" x-small></v-text-field>
								</th> 
								<th colspan="4"></th> 
							</tr>
                            <tr>
                                <th >Kategori</th>
                                <th >Ürün Adı</th>
                                <th style="number">Unit KG</th>
                                <th class="number">Alış</th>
                                <th class="number">Satış</th>
                                <th style="width:1%;" class="actions"></th>
                            </tr>
                        </thead>
                        <tbody class="no-border-x">
                            <tr v-for="(item, itemIndex) in getItems" :key="itemIndex" @click="editItem(item)">
                                <td >
									<span class="prodcuts-category-color-dot" :style="{'background-color' : item.category.color}"></span>
									{{item.category.name}}
								</td> 
                                <td  >
									{{item.name}} 
								</td> 
                                <td class="number">{{item.unit_kg}}</td>
                                <td class="number">{{item.price_buy}} {{item.kur}}</td>
                                <td class="number">{{item.price_sell}} {{item.kur}}</td> 
                                <td class="actions">
									<v-btn tile small icon color="indigo" dark >
										<v-icon>{{mdiTooltipEdit}}</v-icon>
									</v-btn> 
								</td>
                            </tr> 
                        </tbody>
                    </table>
                </template>
            </panelcontainer>

            <v-layout row>

 

                <v-dialog v-model="dialogEditor" persistent max-width="600px">
                    <v-card>
                        <v-card-title>
                            <span class="headline" v-if="item.id">Düzenle</span>
                            <span class="headline" v-if="!item.id">Yeni Ekle</span>
                        </v-card-title>
                        <v-card-text>
                            <v-container grid-list-md>
                                <v-layout wrap>
                                    <v-flex xs12 mb-3>
										<v-select
											v-model="item.category_id"
											:items="categories"
											item-text="name"
											item-value="id"
											label="Kategori"
											outlined
											hide-details
										></v-select> 
                                    </v-flex>
                                    <v-flex xs12 mb-3>
                                        <v-text-field label="Ürün Adı" v-model="item.name" outlined hide-details placeholder="Örn: Solisium"></v-text-field>
                                    </v-flex>
                                    <v-flex xs3 mb-3>
                                        <v-text-field label="Unit KG" v-model="item.unit_kg" outlined hide-details placeholder="Örn: 6.30"></v-text-field>
                                    </v-flex>
                                    <v-flex xs3 mb-3>
                                        <v-text-field label="Alım Fiyatı" v-model="item.price_buy" outlined hide-details placeholder="Örn: 85.00"></v-text-field>
                                    </v-flex>
                                    <v-flex xs3 mb-3>
                                        <v-text-field label="Satış Fiyatı" v-model="item.price_sell" outlined hide-details placeholder="Örn: 100.00"></v-text-field>
                                    </v-flex> 
                                    <v-flex xs3 mb-3>
                                        <v-select
											v-model="item.kur"
											:items="kurs" 
											label="Kur"
											outlined
											hide-details
										></v-select> 
                                    </v-flex> 
                                </v-layout>
                            </v-container>
                        </v-card-text>
                        <v-card-actions class="pr-4 pl-4 pb-4">
							<v-btn color="error darken-1" text  @click="askForRemove()" v-if="item.id"> Ürünü Sil</v-btn> 
							<v-spacer></v-spacer> 
							<v-btn color="warning" round outlined @click="closeItem()">İptal</v-btn>
							<v-btn color="success" round outlined @click="saveItem()">Kaydet</v-btn>
                        </v-card-actions>
                    </v-card>
                </v-dialog>



                <v-dialog v-model="dialogRemove" max-width="290">
                    <v-card>
                        <v-card-title class="headline" color="error"> Silmek itediğine emin misin ?</v-card-title>
                        <v-card-actions>
                            <v-btn color="green darken-1" text @click="closeForRemove()"> Vazgeç </v-btn>
                            <v-spacer></v-spacer>
                            <v-btn color="error darken-1" text @click="removeItem()"> EMİNİM </v-btn>
                        </v-card-actions>
                    </v-card>
                </v-dialog>





            </v-layout>
        </v-container>
    </v-content>


</template>


<script>
    import loading from "@/components/utils/loading"
    import panelcontainer from "@/components/utils/panelcontainer"
    import { 
        mdiPlus, 
        mdiCloseCircle, 
        mdiTooltipEdit, 
        mdiFileExcel, 
    } from '@mdi/js';
    export default {
        components: {
            loading,
            panelcontainer,
        },
        data: () => ({ 
            mdiPlus: mdiPlus, 
            mdiCloseCircle: mdiCloseCircle,  
            mdiTooltipEdit: mdiTooltipEdit,  
            mdiFileExcel: mdiFileExcel,  

            isLoading: false,
            dialogEditor: false,
			dialogRemove: false,
			
			search_category : "",
			search_name : "",

            categories: [],
            items: [],
			item: {},
			
			kurs : ["€","$","₺"],
			
			empty_label : ""
        }),
		mounted(){  
			this.loadCategories();
			this.loadItems();
			this.setNewItemData();
		},
		methods:{
			loadCategories(){
				this.isLoading = true;
				this.$http.get( process.env.VUE_APP_API_URL + "/categories/").then(response => {  
					this.categories = response.body;  
				})  
			},
			loadItems(){
				this.isLoading = true;
				this.$http.get( process.env.VUE_APP_API_URL + "/products/").then(response => {  
					this.items = response.body; 
					this.isLoading = false;
					this.dialogEditor = false;
					this.dialogRemove = false;
				})  
			},
			setNewItemData(){
				this.item = {id:"",name : "",unit_kg : "",price_buy:'',price_sell:'',category_id : 0,kur:'€'}
			},
			editItem(item){
				if(item){
					this.item = item;
				}else{
					this.setNewItemData();
				}
				this.dialogEditor = true;
			},
            closeItem() {
                this.dialogEditor = false
            },
            askForRemove() {
                this.dialogEditor = false;
                this.dialogRemove = true;
            },
            closeForRemove() {
                this.dialogRemove = false;
            },
			saveItem(){
				this.isLoading = true;
				this.$http.post( process.env.VUE_APP_API_URL + "/products/save", this.item).then(response => {  
					this.loadItems();
				}) 
			},
			removeItem(){
				this.isLoading = true;
				this.$http.post( process.env.VUE_APP_API_URL + "/products/remove", this.item).then(response => {  
					this.loadItems();
				}) 
			}
        },
        computed: {
			getProductCategories(){
				var list = {};
				for(var i in this.items){
					for(var c in this.categories){
						if(this.categories[c].id == this.items[i].category_id){
							list[i] = this.categories[c];
						}
					}
				}
				return list;
			},
            getItems() { 
				var items = []; 
				var search_category = this.search_category == null || this.search_category == "" ? "" : this.search_category.seoUrl(); 
				var search_name = this.search_name == null || this.search_name == "" ? "" : this.search_name.seoUrl(); 
				items = this.items.filter( function(item,itemIndex) { 
					if( search_category != ""){
						if( item.category.name.seoUrl().indexOf(search_category) < 0 ){ return false; }
					}
					if( search_name != ""){
						if( item.name.seoUrl().indexOf(search_name) < 0 ){ return false; }
					} 
					return true;
				})  
                return items
            }
        }
    }
</script>

<style lang="less">
	.prodcuts-category-color-dot{
		width:8px;
		height:8px;
		border-radius: 50%;
		display: inline-block;
	}
</style>